import React from 'react'

const AreaTitle = (props) => (
  <div className="area-title text-center wow fadeIn">
    <h2>{props.title}</h2>
      { props.children }
    </div>
)

export default AreaTitle;